import { render, staticRenderFns } from "./DodCustomerOrders.vue?vue&type=template&id=31acd781&scoped=true&"
import script from "./DodCustomerOrders.vue?vue&type=script&lang=js&"
export * from "./DodCustomerOrders.vue?vue&type=script&lang=js&"
import style0 from "./DodCustomerOrders.vue?vue&type=style&index=0&id=31acd781&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31acd781",
  null
  
)

export default component.exports